import { batch, connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import {
  actions as filterActions,
  selectTotalSelectedFilterOptionsCount,
} from 'src/components/organisms/Filter';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { updateFilters, UpdateFiltersActionType } from 'src/redux/products';
import { AppThunkDispatch } from 'src/redux/store';
import { SlimFilterMenu } from '../components/SlimFilterMenu';
import { selectSelectedSortingOptionInSentenceCase } from '../modules/selectors';
import { actions as filterMenuActions } from '../modules/slice';
import { SlimFilterMenuContainerDispatchProps, SlimFilterMenuContainerStateProps } from '../types';

const mapDispatchToProps = (dispatch: AppThunkDispatch): SlimFilterMenuContainerDispatchProps => ({
  onVisible: () => {
    sendGAEvent({
      event: 'custom_event',
      event_action: 'filter & sort sticky impression',
      event_category: 'Filter & sort',
      event_label: 'icon',
    });
  },
  openFilterModal: () => dispatch(filterActions.openModal()),
  onResetFilters: () => {
    batch(() => {
      dispatch(filterActions.resetFilters());
      dispatch(filterMenuActions.resetSelectedSortOption());
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
  },
});

const mapStateToProps = (state: ReduxApplicationState): SlimFilterMenuContainerStateProps => ({
  totalSelectedFilterOptionsCount: selectTotalSelectedFilterOptionsCount(state),
  totalProducts: state.products.totalProducts,
  selectedSortOption: selectSelectedSortingOptionInSentenceCase(state),
  pageProductsCount: state.products.productsReturnedCount,
});

export const SlimFilterMenuContainer = connect(mapStateToProps, mapDispatchToProps)(SlimFilterMenu);
